// extracted by mini-css-extract-plugin
export default {"image":"Image_image__7rtGf","noImage":"Image_noImage__-VuCI"};